import { render, staticRenderFns } from "./QuotaList.vue?vue&type=template&id=32bda3fa"
import script from "./QuotaList.vue?vue&type=script&lang=js"
export * from "./QuotaList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports